module.exports = __webpack_public_path__ + "img/antes_despues_218.e959eb18.png";